<script setup lang="ts">
import { HoverCard, HoverCardContent, HoverCardTrigger } from './ui/hover-card'
import { cn } from '../lib/utils'
import { computed, ref } from 'vue'
import HorizontalLine from './HorizontalLine.vue'
import MoneyFormatted from './MoneyFormatted.vue'

export type FragmentedBarSection = {
  amount: number
  class: string
  showLabel?: boolean
  name: string
}

// todo calculate smaller text size for smaller bars, maybe hide the label if it's too small instead
const props = defineProps<{
  sections: FragmentedBarSection[]
  suffix?: string
}>()

const filteredSections = computed(() => {
  return props.sections.filter((a) => {
    return a.amount != 0
  })
})

const getStringFromSection = computed(() => {
  return (section: FragmentedBarSection) => {
    return section.amount + (props.suffix || 'kr')
  }
})
const getAmountFromSection = computed(() => {
  return (section: FragmentedBarSection) => {
    return (
      section.amount /
      props.sections.reduce((a, b) => {
        return a + b.amount
      }, 0)
    )
  }
})

const divElement = ref()

const showLabelArray = ref<boolean[]>([])

// function shouldShowLabel(el: HTMLDivElement, index: number) {
//   console.log(el.get)
//   return true
//   // const el = divElement.value?.children[index] as HTMLDivElement
//   // if (!el) return true
//   // const parentDivWidth = el.getBoundingClientRect().width - 8 * 2 // px-2
//   // const spanEl = el.firstElementChild as HTMLSpanElement
//   // const spanWidth = spanEl?.getBoundingClientRect().width || 0

//   // return spanWidth < parentDivWidth
// }

// onMounted(() => {
//   showLabelArray.value = filteredSections.value.map((_, index) => {
//     return shouldShowLabel(index)
//   })
// })

// watch(
//   () => props,
//   () => {
//     console.log('watch')

//     showLabelArray.value = filteredSections.value.map((_, index) => {
//       return shouldShowLabel(index)
//     })
//   }
// )

function hideIfTooBigForDiv() {
  for (let el of divElement.value.children as HTMLDivElement[]) {
    const parentDivWidth = el.getBoundingClientRect().width - 8 * 2 // px-2
    const spanEl = el.firstElementChild as HTMLSpanElement
    const spanWidth = spanEl?.getBoundingClientRect().width || 0

    if (spanWidth > parentDivWidth) {
      spanEl.style.opacity = '0'
    }
  }
}

const totalSum = computed(() => {
  return props.sections.reduce((a, b) => a + b.amount, 0)
})

// TODO: make this work
// onMounted(() => {
//   hideIfTooBigForDiv()
// })

// onUpdated(() => {
//   hideIfTooBigForDiv()
// })
</script>

<template>
  <HoverCard>
    <HoverCardTrigger>
      <div class="flex w-full h-full" ref="divElement">
        <div
          v-for="(section, index) in filteredSections"
          :key="index.toString()"
          :class="
            cn('h-full font-semibold text-xs p-1 px-2 text-center overflow-hidden', section.class)
          "
          :style="{
            width: `${Math.abs(getAmountFromSection(section)) * 100}%`,
            'border-radius':
              filteredSections.length == 1
                ? '5px 5px 5px 5px'
                : index === 0
                  ? '5px 0 0 5px'
                  : index === sections.length - 1
                    ? '0 5px 5px 0'
                    : '0',
          }"
        >
          <span>
            {{ section.showLabel ? getStringFromSection(section) : '' }}
          </span>
        </div>
        <div
          v-if="filteredSections.length == 0"
          class="h-full font-semibold text-xs p-1 px-2 text-center"
          :style="{
            width: `100%`,
            'border-radius': '5px 5px 5px 5px',
          }"
        >
          <span> {{ 'No Fees' }} </span>
        </div>
      </div>
    </HoverCardTrigger>
    <HoverCardContent class="flex-col flex gap-4">
      <div v-for="(section, index) in filteredSections" :key="index.toString()">
        <span class="text-sm font-bold">
          {{ section.name }}
        </span>
        <div
          :class="
            cn('h-2 font-semibold text-xs p-1 px-2 text-center overflow-hidden', section.class)
          "
          :style="{
            width: `${Math.abs(getAmountFromSection(section)) * 100}%`,
            'border-radius': '5px 5px 5px 5px',
          }"
        ></div>
        <div class="flex justify-between">
          <span class="text-gray-500 text-sm font-bold">
            {{ (Math.abs(getAmountFromSection(section)) * 100).toFixed(2) }}%
          </span>
          <span class="text-secondaryBlack text-sm font-bold">
            {{ section.showLabel ? getStringFromSection(section) : '' }}
          </span>
        </div>
      </div>
      <HorizontalLine />
      <div class="flex justify-between">
        <span class="text-secondaryBlack font-bold">Total</span>
        <span class="text-gray-500 text-sm font-bold">
          <MoneyFormatted :amount="totalSum" :one-size="true" />
        </span>
      </div>
      <div
        v-if="filteredSections.length == 0"
        class="h-full font-semibold text-xs p-1 px-2 text-center"
        :style="{
          width: `100%`,
          'border-radius': '5px 5px 5px 5px',
        }"
      >
        <span> {{ 'No Fees' }} </span>
      </div>
    </HoverCardContent>
  </HoverCard>
</template>
